module.exports = __webpack_public_path__ + "static/img/9.989e35c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/9.png
// module id = 8Pwa
// module chunks = 0